import each from 'lodash/each'
import { entryScriptName } from 'init/entry-script-name'
import indexOf from 'lodash/indexOf'
import {
  getParamString,
  getPathname,
  getUrlParameters,
  to,
} from './url-helpers'

const CHECKOUT_URL = '/checkout/'

/**
 * Редирект на заданную страницу с поддержкой POST-подтверждения формы.
 * @param {string} url
 * @param {string} [method=GET] Тип запроса (GET, POST)
 * @param {Object} [data]       Поля для POST-подтверждения формы
 */
export const redirect = ({ url, method = 'GET', data }) => {
  if (method === 'POST' && data) {
    const form = document.createElement('form')
    form.setAttribute('action', url)
    form.setAttribute('method', 'POST')
    form.setAttribute('class', 'not_display')
    each(data, (value, key) => {
      const field = document.createElement('input')
      field.name = key
      field.value = value
      form.appendChild(field)
    })
    document.body.appendChild(form)
    form.submit()
  } else
  if (method === 'GET') {
    window.location.assign(url)
  }
}

/**
 * Редирект на страницу заказа
 * @param {Object} [options] Опции (is_remote=true - заказ с удаленного склада)
 * @returns {string} Адрес редиректа
 */
export const goToCheckout = options => {
  let checkoutUrl = entryScriptName + CHECKOUT_URL
  let checkoutParam = {}
  let urlParams = getUrlParameters()

  if (options) {
    if (options.is_remote) {
      checkoutParam = { remote_order: 1 }
    }
    if (options.is_fast_delivery) {
      checkoutParam = { fast_delivery: 1 }
    }
  }
  urlParams = Object.assign(urlParams, checkoutParam)
  checkoutUrl += Object.keys(urlParams).length
    ? `?${getParamString(urlParams)}`
    : ''
  _redirectTo(checkoutUrl)
  return checkoutUrl
}

/**
 * Функция для редиректа
 * Вынесена отдельно для возможности тестирования goToCheckout()
 * @param {string} url Адрес для редиректа
 * @private
 */
const _redirectTo = url => {
  location.href = url
}

/**
 * Редирект на заданную страницу
 * @param {string} path
 */
export const locationAssign = path => {
  let origin = entryScriptName
  if (indexOf(path.split(', '), '?') === 0) {
    origin = ''
  }
  window.location.assign(origin + path)
}

/**
 *  Переход на страницу регистрации
 */
export const goToAuth = () => {
  locationAssign('/auth/')
}

/**
 * Редирект с новыми параметрами
 * @param {Object} params - обьект с параметрами
 */
export const redirectWithNewParams = params => {
  const urlParams = getUrlParameters()
  let url = to(getPathname(), [], { ...urlParams, ...params })
  if (window.location.hash.length) {
    url += window.location.hash
  }
  locationAssign(url)
}

/**
 * Переход по клику количества комментариев на страницу товара с открытыми отзывами
 * @param {number} sid - sid айтемов
 * @param {Function} goToFunction - функция редиректа
 * @returns {Function} Функция редиректа на заданную страницу
 */
export const createGoToProductReview = (sid, goToFunction) => {
  return () => goToFunction(`/${sid}#review`)
}
